import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import {SessionService} from '../../Services/session.service';
import {ActivityListService} from '../../Services/activity-list.service';
import { EventService } from "../../Services/event.service";
@Component({
  selector: 'app-activity-details-sidebar',
  templateUrl: './activity-details-sidebar.component.html',
  styleUrls: ['./activity-details-sidebar.component.css']
})
export class ActivityDetailsSidebarComponent implements OnInit {

  constructor(private activityListService: ActivityListService, private router:Router, private route: ActivatedRoute, private sessionService: SessionService, private httpClientService: HttpClientService, private eventService: EventService) { }
  isSideBarOpen: Boolean = false;
  pageName: any;
  activityId: String;
  data: any;
  sub: any;
  corelationID:String;
  bulletImage = AppSettings.cdnUrl + "assets/images/bullet.png";
  crossImage = AppSettings.cdnUrl + "assets/images/cross.png";
  mobileDots = AppSettings.cdnUrl + "assets/images/3-mobile-dots.png";
  lockImage = AppSettings.cdnUrl + "assets/images/locked_en_act.png";
  coursePopUpFlag:boolean = false;
  isFreeTrialUser:boolean = false;
  activiyLoadImg:string = AppSettings.cdnUrl + "assets/images/activity-loading.gif";
  isActivityLoaded:boolean = false;
  userInfo:any;
  lockActivityData:any = {};
  paceLink:string="";
  paceEnabled:boolean=true;
  showPaceView:boolean=false;
  paceViewLogoIconURL = AppSettings.cdnUrl+'assets/images/pace_view_logo.png';
  skipRightArrowIconURL = AppSettings.cdnUrl+'assets/images/skip_right_arrow_icon.png';
  highlightActivityIconURL = AppSettings.cdnUrl+'assets/images/highlight_activity_icon.png';
  @ViewChild('_activitySideBar', { static: true }) activitySideBar: ElementRef;

  ngOnInit() {
    this.sub = this.route.params.subscribe(
      (params) => {
        // A cementing quiz (page + subject, no activity id) uses the same listing sidebar.
        if(params['activity'] || params['subject'] || params['quizId'])
        {
          this.pageName = params['page'];
          this.activityId = params['activity'] || null;
          this.getData(this.activityId);
        }
        else if(params['corelationid'])
        {
          this.corelationID = params['corelationid'];
          let headers = new HttpHeaders();
          this.httpClientService.get(AppSettings.restApiUrl +
              '/api/link/forum/'+this.corelationID+'/', headers)
          .subscribe( (data) => {
              this.activityId = data.forumObjectId;
              this.pageName = data.pageName;
              this.getData(this.activityId);
      });
        }
      }
    );
    this.sessionService.closeActivitySidebar$
     .subscribe(item => { if(item != 0) { this.isSideBarOpen = false}}
   );
     this.getUserInfo();
  }

  getUserInfo()
  {
    this.userInfo = this.sessionService.getUserInfo$.
    subscribe(data => { if(data != "")
    {
        this.isFreeTrialUser = data.courseEnrollments.freeTrial;
    }});
  }

sideBarOpen()
{
this.isSideBarOpen=true;
this.getData(this.activityId);
this.sessionService.closeForumsSidebar(1);
}

  getData(activityId) {
    this.isActivityLoaded = false;
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/course/' + this.pageName, headers)
      .subscribe(
      (data) => {
        this.data = data;
        this.showPaceView = data.paceSystemEnabled;
        this.data = this.activityListService.getData(this.data);
        for (var i = 0; i < data.topics.length; i++) {
          for (var j = 0; j < data.topics[i].activities.length; j++) {
            if (data.topics[i].activities[j].id == activityId) {
              data.topics[i].isVisible = true;
            }
          }

        }
        this.isActivityLoaded = true;
      }
      )
  }

  closeOtherSideBar(event)
  {
    var el  = event.target;
    var closeSidebar = false;
    while ((el = el.parentElement))
    {
      if(el == this.activitySideBar.nativeElement)
      {
        return;
      }
    };
    this.isSideBarOpen = false;
  }

  validateCoursePopUp(hasAccess:boolean, activityName:string, moduleName:string, courseName:string, activityId:number)
  {
    if(!hasAccess)
    {
        this.coursePopUpFlag = true;
        this.lockActivityData["coursePopUpFlag"] = true;
        this.lockActivityData["isFreeUser"] = this.isFreeTrialUser;
        this.lockActivityData["upgradeURL"] = AppSettings.publicSiteURL+"/pricing/complete-gmat-preparation-courses/";
        document.body.classList.add('coursePopIn');
        let kmProperties = {};
        kmProperties['ALA_Content'] = activityName;
        kmProperties['ALA_Module'] = moduleName;
        kmProperties['ALA_Course'] = courseName;
        this.eventService.track("Accessed Locked Activity",kmProperties);
        if(!this.isFreeTrialUser)
        {
          this.getUpgradeURL(activityId);
        }
    }
  }
  changePopUpFlag(flag:boolean)
  {
    this.coursePopUpFlag = flag;
  }
  ngOnDestroy()
  {
      this.userInfo.unsubscribe();
  }

  getUpgradeURL(activityId:number)
  {
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/user/upgrade/activity/' + activityId, headers)
      .subscribe(
      (data) =>
      {
        this.lockActivityData["upgradeURL"] = data.upgradeURL;
      });
  }

  routeToActivity(activity)
  {
    if(activity.isArchived)
    {
      let eventName = "Click Obsolete Activity";
      let computedProperties = {
        "activity_name":activity.activityName,
        "trigger_location":"activity list - sidebar"
      };
      this.eventService.track(eventName,computedProperties);
      let url = "/archived/page/" + this.pageName + "/activity/" + activity.id;
      this.router.navigateByUrl(url);
    }
  }
  truncateString(activityName)
  {
    if(activityName.length>32)
    {
      return activityName.substring(0,33)+'...';
    }
      return activityName
  }
  getTotalActivities(topic)
  {
    if(this.paceEnabled)
    {
        return topic.activities.filter(item => item['paceAction']!="HIDE" && item['paceAction']!="DEHIGHLIGHT").length;
    }
    else
    {
      return topic.activities.length;
    }
  }
  getTotalCompletedActivities(topic)
  {
    if(this.paceEnabled)
    {
        return topic.activities.filter(item => item['paceAction']!="HIDE" && item['paceAction']!="DEHIGHLIGHT" && (item['userState']=='COMPLETED_AUTO' || item['userState']=='COMPLETED_MANUAL' || item['userState']=='REVISION')).length;
    }
    else
    {
      return topic.activities.filter(item => (item['userState']=='COMPLETED_AUTO' || item['userState']=='COMPLETED_MANUAL' || item['userState']=='REVISION')).length;;
    }
  }
  togglePace(event)
  {
    let isChecked = event.target.checked;
    this.paceEnabled = isChecked;
    console.log(event,this.paceEnabled);
  }
}
